import React from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';

import Content from '../../public/content/footer.json';

// 3rd Party
import smoothScroll from 'smoothscroll';
import Collapse from 'react-collapse';

class Footer extends React.Component {
  movePage(height) {
    if (height !== 0) {
      smoothScroll(document.body.scrollHeight);
    }
  }

  render() {
    return (
      <Router>
        <footer className="page-footer">
          <div className="wrap">
            <div className="left-column">
              <p dangerouslySetInnerHTML={{ __html: Content.left_column }} />
            </div>
            <div className="right-column">
              <p dangerouslySetInnerHTML={{ __html: Content.right_column }} />
            </div>
            <Route path="/impressum" children={({ match }) => (
              <div>
                <div className="imprint-label">
                  <p>Impressum & Datenschutz:</p>
                  <Link to={match ? '/' : '/impressum'} className={match ? 'read-more active' : 'read-more'} />
                </div>

                <Collapse isOpened={match} className="impressum-full" onHeightReady={(height) => this.movePage(height)}>
                  <div className="content">
                    <div className="left-content">
                      <p dangerouslySetInnerHTML={{ __html: Content.full_content_left }} />
                    </div>
                    <div className="right-content">
                      <p dangerouslySetInnerHTML={{ __html: Content.full_content_right }} />
                    </div>
                  </div>
                </Collapse>
              </div>
            )} />
          </div>
        </footer>
      </Router>
    );
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/layout/footer.jsx